(function () {
  'use strict';

  var FINISHES = ['silver', 'gold', 'black', 'rose'];

  function initReveal() {
    var items = document.querySelectorAll('.pg-reveal, .pg-reveal-scale');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -30px 0px' }
    );

    items.forEach(function (el, i) {
      if (!el.style.getPropertyValue('--pg-delay')) {
        el.style.setProperty('--pg-delay', Math.min(i * 80, 400) + 'ms');
      }
      observer.observe(el);
    });
  }

  function fitTagText(tagEl) {
    if (!tagEl) return;
    tagEl.style.fontSize = '';
    var size = parseFloat(window.getComputedStyle(tagEl).fontSize);
    var min = 9;
    while (tagEl.scrollWidth > tagEl.clientWidth && size > min) {
      size -= 0.5;
      tagEl.style.fontSize = size + 'px';
    }
  }

  function normalizeFinish(value) {
    var text = (value || '').toLowerCase();
    if (/rose|pink|blush/.test(text)) return 'rose';
    if (/gold|yellow/.test(text)) return 'gold';
    if (/black|onyx|matte black/.test(text)) return 'black';
    if (/silver|white|chrome|steel/.test(text)) return 'silver';
    return FINISHES.indexOf(text) > -1 ? text : 'silver';
  }

  function initTagStudio() {
    var studio = document.querySelector('[data-pg-tag-studio]');
    if (!studio) return;

    var nameInput = studio.querySelector('[data-pg-tag-name]');
    var preview = studio.querySelector('[data-pg-tag-preview]');
    var stage = studio.querySelector('[data-pg-tag-stage]');
    var finishButtons = studio.querySelectorAll('[data-pg-finish]');
    var cta = studio.querySelector('[data-pg-tag-cta]');

    if (!nameInput || !preview) return;

    var updateName = function () {
      var value = nameInput.value.trim();
      preview.textContent = value || 'Bella';
      fitTagText(preview);
    };

    var updateFinish = function (finish) {
      preview.setAttribute('data-finish', finish);
      finishButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-pg-finish') === finish);
      });
    };

    nameInput.addEventListener('input', updateName);
    window.addEventListener('resize', function () { fitTagText(preview); });

    finishButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateFinish(btn.getAttribute('data-pg-finish'));
      });
    });

    if (stage && window.matchMedia('(pointer: fine)').matches) {
      studio.addEventListener('mousemove', function (e) {
        var rect = studio.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        stage.style.transform = 'rotateY(' + (x * 18) + 'deg) rotateX(' + (-y * 12) + 'deg)';
      });
      studio.addEventListener('mouseleave', function () {
        stage.style.transform = '';
      });
    }

    if (cta) {
      cta.addEventListener('click', function (e) {
        var name = nameInput.value.trim();
        if (!name) {
          e.preventDefault();
          nameInput.focus();
          return;
        }
        e.preventDefault();
        var finish = preview.getAttribute('data-finish') || 'silver';
        var base = cta.getAttribute('href') || '/collections/all';
        var sep = base.indexOf('?') > -1 ? '&' : '?';
        window.location.href = base + sep + 'pg_name=' + encodeURIComponent(name) + '&pg_finish=' + finish;
      });
    }

    updateName();
    updateFinish('silver');
  }

  function initHeaderScroll() {
    var headerGroup = document.getElementById('header-group');
    if (!headerGroup) return;

    var onScroll = function () {
      headerGroup.classList.toggle('pg-header-scrolled', window.scrollY > 50);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initHeroParallax() {
    var hero = document.querySelector('.pg-hero');
    if (!hero || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var media = hero.querySelector('.pg-hero__media img');
    if (!media) return;

    window.addEventListener('scroll', function () {
      var rect = hero.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      var progress = Math.max(0, -rect.top / rect.height);
      media.style.transform = 'scale(' + (1 + progress * 0.08) + ') translateY(' + (progress * 40) + 'px)';
    }, { passive: true });
  }

  function findCustomizerInputs() {
    return Array.from(document.querySelectorAll('input:not([type="hidden"]), textarea')).filter(function (input) {
      if (input.matches('[data-pg-pet-name-field], [data-pg-tag-name], .pg-globo-sr-only, .pg-globo-hidden')) return false;
      var label = input.closest('label');
      var hint = (
        input.name + input.placeholder + input.id +
        (input.getAttribute('aria-label') || '') +
        (label ? label.textContent : '')
      ).toLowerCase();
      return /name|pet|engrav|tag|custom|text|your/.test(hint);
    });
  }

  function ensureCartProperty(name) {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form || !name) return;
    var input = form.querySelector('[name="properties[Pet Name]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[Pet Name]';
      form.appendChild(input);
    }
    input.value = name;
  }

  function getProductDetailsRoot() {
    return document.querySelector('.product-details');
  }

  function findGloboAppBlock() {
    var root = getProductDetailsRoot();
    if (!root) return null;
    return root.querySelector('[class*="globo"]') ||
      root.querySelector('#globo-product-options') ||
      root.querySelector('.shopify-app-block');
  }

  function isGloboNameField(input) {
    var hint = (
      input.name + input.id + input.placeholder +
      (input.getAttribute('aria-label') || '') +
      (input.closest('label') ? input.closest('label').textContent : '')
    ).toLowerCase();
    return /name|pet|engrav|tag|text|your|custom/.test(hint);
  }

  function bindGloboSync(ourInput, globoBlock) {
    if (!ourInput || !globoBlock) return;

    globoBlock.setAttribute('data-pg-globo-hidden', 'true');

    globoBlock.querySelectorAll('input, textarea').forEach(function (input) {
      if (input.matches('[data-pg-pet-name-field]') || !isGloboNameField(input)) return;
      input.classList.add('pg-globo-sr-only');
      input.removeAttribute('readonly');
      input.removeAttribute('disabled');

      if (input.dataset.pgGloboSync) return;
      input.dataset.pgGloboSync = '1';

      var syncToGlobo = function () {
        input.value = ourInput.value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };

      ourInput.addEventListener('input', syncToGlobo);
      ourInput.addEventListener('blur', syncToGlobo);
      if (ourInput.value) syncToGlobo();
    });
  }

  function syncPetName(value, source) {
    var trimmed = (value || '').trim();
    document.querySelectorAll('[data-pg-pet-name-field], [data-pg-tag-name]').forEach(function (input) {
      if (input === source) return;
      if (input.value !== value) input.value = value;
    });

    findCustomizerInputs().forEach(function (input) {
      if (input === source) return;
      if (input.value !== value) {
        input.value = value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    ensureCartProperty(trimmed);

    var preview = document.querySelector('[data-pg-pdp-preview]');
    var tag = document.querySelector('[data-pg-pdp-tag]');
    if (preview && tag) {
      preview.removeAttribute('hidden');
      tag.textContent = trimmed || 'Bella';
      fitTagText(tag);
    }
  }

  function bindPetNameInputs() {
    document.querySelectorAll('[data-pg-pet-name-field]').forEach(function (input) {
      if (input.dataset.pgBound) return;
      input.dataset.pgBound = '1';
      input.addEventListener('input', function () {
        syncPetName(input.value, input);
      });
    });
  }

  function initProductCustomizer() {
    var ourInput = document.querySelector('[data-pg-pet-name-field]');
    if (!ourInput) return;

    var refreshGlobo = function () {
      bindPetNameInputs();
      bindGloboSync(ourInput, findGloboAppBlock());
    };

    refreshGlobo();

    var globoBlock = findGloboAppBlock();
    if (globoBlock && 'MutationObserver' in window) {
      var observer = new MutationObserver(refreshGlobo);
      observer.observe(globoBlock, { childList: true, subtree: true });
    }

    [400, 1200, 2500].forEach(function (delay) {
      window.setTimeout(refreshGlobo, delay);
    });
  }

  function bindVariantFinishSync() {
    var preview = document.querySelector('[data-pg-pdp-preview]');
    var tag = document.querySelector('[data-pg-pdp-tag]');
    if (!tag) return;

    var applyFinish = function (value) {
      tag.setAttribute('data-finish', normalizeFinish(value));
    };

    document.querySelectorAll('input[type="radio"][name*="option"], select[name*="option"]').forEach(function (el) {
      el.addEventListener('change', function () {
        if (el.checked || el.tagName === 'SELECT') {
          applyFinish(el.value || el.getAttribute('data-option-value') || '');
        }
      });
      if (el.checked || (el.tagName === 'SELECT' && el.value)) {
        applyFinish(el.value || el.getAttribute('data-option-value') || '');
      }
    });

    document.addEventListener('variant:update', function (event) {
      var detail = event.detail || {};
      var variant = detail.variant || detail.resource;
      if (!variant || !variant.options) return;
      variant.options.forEach(function (option) {
        applyFinish(option);
      });
    });
  }

  function initProductPage() {
    var template = document.querySelector('[data-template]');
    if (!template || template.getAttribute('data-template') !== 'product') return;

    var params = new URLSearchParams(window.location.search);
    var name = params.get('pg_name');
    var finish = normalizeFinish(params.get('pg_finish') || 'silver');
    var preview = document.querySelector('[data-pg-pdp-preview]');
    var tag = document.querySelector('[data-pg-pdp-tag]');

    if (preview && tag && name) {
      preview.removeAttribute('hidden');
      tag.textContent = decodeURIComponent(name);
      tag.setAttribute('data-finish', finish);
      fitTagText(tag);
    } else if (preview && tag) {
      preview.removeAttribute('hidden');
      tag.textContent = 'Bella';
      fitTagText(tag);
    }

    bindPetNameInputs();
    bindVariantFinishSync();

    var cartForm = document.querySelector('form[data-type="add-to-cart-form"]');
    if (cartForm && !cartForm.dataset.pgPetNameSubmit) {
      cartForm.dataset.pgPetNameSubmit = '1';
      cartForm.addEventListener('submit', function () {
        var input = document.querySelector('[data-pg-pet-name-field]');
        if (input) ensureCartProperty(input.value.trim());
      });
    }

    setTimeout(function () {
      var petInput = document.querySelector('[data-pg-pet-name-field]');

      if (petInput && name) {
        petInput.value = decodeURIComponent(name);
      }

      findCustomizerInputs().forEach(function (input) {
        if (input.dataset.pgBound) return;
        input.dataset.pgBound = '1';
        input.addEventListener('input', function () {
          syncPetName(input.value, input);
        });
        if (name && !input.value) {
          input.value = decodeURIComponent(name);
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });

      if (petInput && name) syncPetName(decodeURIComponent(name), petInput);

      bindPetNameInputs();
      bindGloboSync(petInput, findGloboAppBlock());
      bindVariantFinishSync();
    }, 600);
  }

  function initSmoothAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href');
        if (id.length < 2) return;
        var target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initFab() {
    var fab = document.querySelector('.pg-fab');
    if (!fab) return;

    var onScroll = function () {
      fab.classList.toggle('is-visible', window.scrollY > 400);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var studio = document.querySelector('[data-pg-tag-studio]');
    if (studio && 'IntersectionObserver' in window) {
      var studioObserver = new IntersectionObserver(
        function (entries) {
          fab.classList.toggle('is-hidden-near-studio', entries[0].isIntersecting);
        },
        { threshold: 0.15, rootMargin: '0px 0px -80px 0px' }
      );
      studioObserver.observe(studio);
    }
  }

  function initLoader() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var loader = document.createElement('div');
    loader.className = 'pg-loader';
    loader.innerHTML = '<div class="pg-loader__tag" aria-hidden="true"></div>';
    document.body.prepend(loader);
    window.addEventListener('load', function () {
      setTimeout(function () { loader.classList.add('is-done'); }, 300);
    });
  }

  function boot() {
    initLoader();
    initReveal();
    initTagStudio();
    initHeaderScroll();
    initHeroParallax();
    initProductCustomizer();
    initProductPage();
    initSmoothAnchors();
    initFab();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
